import { useEffect, useState } from "react";
import API from "../../config/api";
import { useTranslation } from "../../i18n/LanguageProvider";
import "./Contacts.sass";
import ContactForm from "./Components/ContactForm";
import ContactInfo from "./Components/ContactInfo";

const INITIAL_FORM_DATA = {
    name: "",
    email: "",
    subject: "",
    message: "",
};

function Contacts() {
    const { language, t } = useTranslation();
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim() || !formData.message.trim()) {
            setSubmitStatus({ type: "error", message: t("contact.requiredError") });
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${API.support}?lang=${language}`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.success) {
                setSubmitStatus({ type: "success", message: result.message });
                setFormData(INITIAL_FORM_DATA);
                setTimeout(() => setSubmitStatus(null), 5000);
            } else {
                setSubmitStatus({ type: "error", message: result.error });
            }
        } catch (err) {
            console.error("Error submitting form:", err);
            setSubmitStatus({ type: "error", message: t("contact.sendError") });
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="contacts general-wrapper">
            <header className="contacts__header">
                <h1 className="contacts__title">{t("contact.title")}</h1>
                <p className="contacts__intro">{t("contact.intro")}</p>
            </header>

            <div className="contacts__grid">
                <ContactInfo />
                <ContactForm
                    formData={formData}
                    loading={loading}
                    submitStatus={submitStatus}
                    onChange={handleChange}
                    onSubmit={handleSubmit}
                />
            </div>
        </main>
    );
}

export default Contacts;
